document.addEventListener('DOMContentLoaded', function () {
  initSwiper();

  // 初始化swiper
  function initSwiper() {
    const swiperInstance = new Swiper('#collect-swiper', {
      effect: 'slide',
      autoHeight: true,
      slideClass: 'swiper-slide',
      spaceBetween: 20,
    });

    // 滑动事件
    const params = new URLSearchParams(window.location.search);
    const tab = params.get('tab');

    const buttons = document.querySelectorAll('.collect-type-bar button');
    let activeIndex = 0;

    buttons.forEach((btn, index) => {
      if (btn.dataset.tab === tab) {
        activeIndex = index;
      }

      btn.addEventListener('click', () => {
        buttons.forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');
        swiperInstance.slideTo(index);

        const url = new URL(window.location);
        url.searchParams.set('tab', btn.dataset.tab);
        window.history.replaceState({}, '', url);
      });
    });

    swiperInstance.slideTo(activeIndex);
    buttons[activeIndex].classList.add('active');

    swiperInstance.on('slideChange', () => {
      const newIndex = swiperInstance.activeIndex;
      buttons.forEach((b) => b.classList.remove('active'));
      if (buttons[newIndex]) {
        buttons[newIndex].classList.add('active');

        const newTab = buttons[newIndex].dataset.tab;
        const url = new URL(window.location);
        url.searchParams.set('tab', newTab);
        window.history.replaceState({}, '', url);
      }
    });
  }
});

class CollectionProductCard extends HTMLElement {
  variants;
  current;
  btnLoading = false;
  form;
  btn;
  mb_modal;
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {}

  init() {
    this.dialog = this.querySelector('dialog');

    this.form = this.querySelector('form');
    this.btn = this.querySelector('.add-btn');
    this.variants = JSON.parse(this.dataset.variants);
    this.current = JSON.parse(this.dataset.current);
    this.mb_modal = this.querySelector('collection-card-modal');
    this.cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    if (this.form) {
      this.form.addEventListener('change', (e) => {
        const options = Array.from(
          this.form.querySelectorAll("input[type='radio']:checked")
        ).map((e) => e.value);

        this.current = this.variants.find(
          (variant) =>
            JSON.stringify(variant.options) === JSON.stringify(options)
        );
        this.changeImage();
        this.updatePrice();
      });
    }
    if (this.mb_modal) {
      this.querySelector('.mb_cart').addEventListener('click', () => {
        if (this.variants.length == 1) {
          if (this.btnLoading) {
            return;
          }
          this.onSubmitHandler();
        } else {
          this.mb_modal.showModal();
        }
      });
    }

    if (this.btn) {
      this.btn.addEventListener('click', () => {
        if (this.btnLoading) {
          return;
        }

        this.onSubmitHandler();
      });
    }
  }

  changeImage() {
    this.querySelector('img').srcset = this.current.featured_image.src;
  }

  updatePrice() {
    const showbefore = this.current.price < this.current.compare_at_price;
    this.querySelector('.price').innerHTML = this.moneyWithoutTrailingZeros(
      this.current.price
    );
    this.querySelector('.before').innerHTML = showbefore
      ? this.moneyWithoutTrailingZeros(this.current.compare_at_price)
      : '';
  }

  // 价格转换
  moneyWithoutTrailingZeros(cents, currency) {
    const money = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
    }).format(cents / 100);
    return money.replace(/\.00$/, '');
  }

  async onSubmitHandler() {
    dataLayer.push({
      event: 'market/add',
      timestamp: new Date().toISOString(),
      isApp: USER_AGENT.isApp,
      uaMessage: USER_AGENT,
      productList: [
        {
          name: this.current.name,
          id: this.current.id,
          options: this.current.options,
          num: 1,
        },
      ],
    });
    const data = {
      items: [
        {
          id: this.current.id,
          quantity: 1,
        },
      ],
      sections: 'cart-drawer,cart-icon-bubble',
    };

    this.toggleLoading();
    await fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((response) => {
        if (this.dialog && this.variants.length !== 1) {
          this.closeModal();
        }
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: this.mainProductId,
            errors: response.errors || response.description,
            message: response.message,
          });
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: this.mainProductId,
            cartData: response,
          });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty');
        this.toggleLoading();
      });
  }
  closeModal() {
    this.dialog.close();
  }

  toggleLoading() {
    this.btnLoading = !this.btnLoading;
    this.classList.toggle('is-loading');
  }
}

class CollectionCardModal extends CollectionProductCard {
  constructor() {
    super();
  }

  disconnectedCallback() {}

  showModal() {
    if (this.dialog) this.dialog.showModal();
  }
  closeModal() {
    this.dialog.close();
  }
}

customElements.define('collection-product-card', CollectionProductCard);
customElements.define('collection-card-modal', CollectionCardModal);
